var map = {
	"./clock.svg": 478,
	"./community.svg": 479,
	"./cube.svg": 480,
	"./education.svg": 481,
	"./facebook.svg": 482,
	"./initial-exam.svg": 483,
	"./instagram.svg": 484,
	"./knowledge.svg": 485,
	"./location-01.svg": 486,
	"./personal.svg": 487,
	"./phone-01.svg": 488,
	"./smiley-face.svg": 489,
	"./snapchat.svg": 490,
	"./sponsorship.svg": 491
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 531;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = 531
// module chunks = 1